import { useEffect, useState } from "react";
import { loadProductStatusMap } from "../Constants/productOrderStatus";

/**
 * The catalog status id ⇄ name map for one vertical, loaded from the backend.
 *
 * Status ids are DB rows, so nothing on the client hardcodes them: components
 * work in status NAMES and translate through this map at the edges (the socket
 * payloads carry ids, and the update endpoint takes one). COMY1-283.
 *
 * `ready` is false until the map arrives — callers that must send an id should
 * wait on it rather than guess.
 */
const useProductStatusMap = (itemType = "product") => {
  const [map, setMap] = useState({ idByName: {}, nameById: {} });
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let active = true;
    setReady(false);
    loadProductStatusMap(itemType).then((loaded) => {
      if (!active) return;
      setMap(loaded);
      setReady(Object.keys(loaded.idByName).length > 0);
    });
    return () => {
      active = false;
    };
  }, [itemType]);

  return { ...map, ready };
};

export default useProductStatusMap;
